import { useState, useEffect, useMemo } from "react";
// import Cleave from "cleave.js/react";
import { Link } from "react-router-dom";
//import "cleave.js/dist/addons/cleave-phone.us";
//---------------------------------------------
import Modal from "src/components/common/modal";
import { myOptions } from "src/components/personel/userForm";
import { useMyStore } from "src/components/main/mainStore";
import {
    numberReducer, FileInput, myAxios, 
    MyFormData, round, Select, 
    poApproverMap, defaultPOApproverEmail, 
    isDevMode, objAscSort
} from "src/components/common/functions";
//---------------------------------------------
export default function PurchaseForm({
    approval, 
    keyword, 
    handleSubmit, 
    closeIt, 

    vendorList, 
    usersList, usersListMap, 
    paymentMethodsData = { paymentMethods: [], types: [] },

    quoteLink, 
    receiptLink, 
    projectHashKey, 
    requestorEmail, 
    paymentMethod, 
    last4, 
    billable, 
    truckNumber, 
    data, 
    tax, 
    discount, 
    notes, 
    poNumber, 
    poDate, 
    formId, 
    excelId, 
    poType, 
    category, 
    includedInProposal,
    permit, 
    department, 
    clientInvoiceNumber
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [projectsList, setProjectsList] = useState([]);
    const [fleetList, setFleetList] = useState([]);
    const projectsListMap = Object.fromEntries(projectsList.map(project => [project.projectHashKey, project]));
    //---------------------------------------------
    const defaultApprover = approval?usersListMap[JSON.parse(approval)[0].candidateEmail?.[0]]:undefined;
    const defaultRequestorEmail = requestorEmail?usersListMap[requestorEmail]:undefined;
    //---------------------------------------------
    const [curProjectHashKey, setProjectHashKey] = useState(projectHashKey || "");
    const [poInvalid, setPoInvalid] = useState("");
    const [curPoNumber, setPoNumber] = useState(poNumber || "");
    const [curTruckNumber, setTruckNumber] = useState(truckNumber?JSON.parse(truckNumber):[]);
    const [curRequestorEmail, setRequestorEmail] = useState(defaultRequestorEmail);
    const [curApprover, setApprover] = useState(defaultApprover);
    const [curBillable, setBillable] = useState(billable || "");
    const [curIncludedInProposal, setIncludedInProposal] = useState(includedInProposal || "");
    const [curCategory, setCategory] = useState(category || "");
    const [pM, setPM] = useState(paymentMethod || "");
    const [curData, setData] = useState((data && JSON.parse(data)) || [{vendor: "", description: "", unitPrice: "", quantity: "", lineTotal: ""}]);
    const [curTax, setTax] = useState(tax || "");
    const [curDiscount, setDiscount] = useState(discount || "");
    //---------------------------------------------
    // Filter last4 options based on selected payment method
    const availableLast4Options = useMemo(() => {
        if (!pM) return [];
        return paymentMethodsData.paymentMethods
            .filter(pm => pm.type === pM && pm.last4 && pm.last4.trim() !== '')
            .map(pm => pm.last4);
    }, [pM, paymentMethodsData.paymentMethods]);
    //---------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async() => {
            setShowLoader(true);
            const resFleet = await myAxios("common/readFleet.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resFleet) return;
            //------------------------------------------------------------
            setFleetList(resFleet.data);
            //------------------------------------------------------------
            setShowLoader(true);
            const resProjects = await myAxios("projects/readProjectsForPurchase.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resProjects) return;
            //------------------------------------------------------------
            const mainData = resProjects.data.map(p => ({...p, projectName: `${p.projectName}`}))
            .sort((a, b) => objAscSort(a, b, "projectName"));
            setProjectsList(mainData.map(project => ({...project, label: project.projectName, value: project.projectHashKey})));
        }
        getData();
        return () => {isMounted = false}
    },[setShowLoader]);
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"1200px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div>
                <input className = "nodisplay" readOnly name = "data" value = {JSON.stringify(curData)}/>
                <input className = "nodisplay" readOnly name = "action" value = {keyword}/>
                <input className = "nodisplay" readOnly name = "prePoNumber" value = {poNumber}/>
                <input className = "nodisplay" readOnly name = "prePaymentMethod" value = {paymentMethod}/>
                <input className = "nodisplay" readOnly name = "form" value = {"poForm"}/>
                <input className = "nodisplay" readOnly name = "formId" value = {formId}/>
                <input className = "nodisplay" readOnly name = "receiptLink" value = {receiptLink}/>
                <input className = "nodisplay" readOnly name = "quoteLink" value = {quoteLink}/>
                <input className = "nodisplay" readOnly name = "excelId" value = {excelId}/>
                <input className = "nodisplay" readOnly name = "poType" value = {poType}/>
                <div style = {{color:"red", textAlign: "center", margin: "1em", fontWeight: 650, fontSize: "2em"}}>
                    {pM === "Pay by personal account"?"Reimbursement Form":"Purchase Request Form"}
                </div>
                <div className = "text-secondary font-weight-bold text-danger h4">NOTE: If reimbursement is not submitted by COB (Close of Business) Tuesday, it will not be processed until the next paydate.</div>
                <div className = "my-4">
                    <label htmlFor = "poNumber" className = "font-weight-bold mr-3 required-field inline">
                        PO Number: 
                    </label>
                    <input
                        required = {true}
                        readOnly = {keyword === "Update" && false}
                        type = {"text"} className = {"form-control"}
                        id = {"poNumber"}
                        name = {"poNumber"}
                        value = {curPoNumber}
                        onChange = {e => setPoNumber(e.currentTarget.value.replace(/\//g, "").replace(/ /g, "").replace(/\?/g, ""))}
                        onBlur = {async e => {
                            const target = e.currentTarget.value.replace(/\//g, "").replace(/ /g, "");
                            if(target === poNumber){
                                return;
                            }
                            if(!target){
                                setPoInvalid("");
                                return;
                            }
                            const formData = new MyFormData();
                            formData.append("poNumber", target);
                            //------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("purchases/checkDuplicatePO.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------------------------------------------
                            setPoInvalid(res.data);
                        }}
                    />
                    {poInvalid?
                    <span className = {"mx-3 text-danger font-weight-bold"}>
                        duplicated with &nbsp;
                        <Link to = {`/Purchases/${poInvalid}`}>
                            {poInvalid}
                        </Link>
                    </span>
                    :<></>}
                    <input
                        readOnly className = {"nodisplay"}
                        name = {"poInvalid"} value = {poInvalid}
                    />
                </div>
                <div className = "my-4">
                    <label htmlFor = "poDate" className = {"font-weight-bold mr-3 required-field inline"}>
                        PO Date:
                    </label>
                    <input
                        required = {true}
                        type = {"date"}
                        min = {"1999-12-31"}
                        max = {"2999-12-31"}
                        className = {"form-control"}
                        id = {"poDate"}
                        name = {"poDate"}
                        defaultValue = {poDate || ""}
                    />
                </div>
                <div className = {"my-4"}>
                    <label htmlFor = {"category"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Expense Category:
                    </label>
                    <select
                        required = {true}
                        className = {"form-control"}
                        id = {"category"}
                        name = {"category"}
                        value = {curCategory}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setCategory(value);
                            const approverEmail = poApproverMap[value] ?? defaultPOApproverEmail;
                            if(approverEmail !== "michael@besstestlab.com") setApprover(usersListMap[approverEmail]);
                            else setApprover(null);
                        }}
                    >
                        <option value = "">Select</option>
                        <option>Project Expense</option>
                        <option>Outside Service Expense</option>
                        <option>Office Supply</option>
                        <option>Vehicle Maintenance</option>
                        <option>Equipment Expense</option>
                        <option>Equipment Maintenance</option>
                        <option>Yard Material</option>
                        <option>Vehicle Rental</option>
                        <option>Traffic Control Related</option>
                        <option>Subscription</option>
                        <option>In-House Training</option>
                        <option>QA/QC</option>
                        <option>Marketing</option>
                        <option>Safety</option>
                        <option>Accommodation</option>
                        <option>Saw Cutting</option>
                        <option>Scanning & Coring Materials</option>
                        <option>Sponsor</option>
                    </select>
                </div>
                {curCategory === "Project Expense"?
                <div className = {"my-4"} style = {{display: "flex", alignItems: "center"}}>
                    <label htmlFor = "projectName" className = "font-weight-bold mr-3 required-field inline">
                        Project Name:
                    </label>
                    <div style = {{flexGrow: 1}}>
                        <Select
                            name = {"projectHashKey"}
                            required
                            inputId = "projectName"
                            value = {projectsListMap[curProjectHashKey]}
                            options = {projectsList}
                            onChange = {e => {
                                setProjectHashKey(e?.value);
                                if(!e?.value) return;
                                setApprover(usersListMap[
                                    projectsListMap[e?.value]?.projectManagerEmail
                                ]);
                            }}
                        />
                        <input 
                            className = {"nodisplay"} readOnly
                            name = {"projectName"}
                            value = {projectsListMap[curProjectHashKey]?.projectName ?? ""} 
                        />  
                    </div>  
                </div>
                :null}
                <div className = {"my-4"}>
                    <label htmlFor = {"approver"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Approver:
                    </label>
                    <Select
                        divStyle = {{minWidth: 300, display: "inline-block"}}
                        name = {"approverEmail"}
                        required
                        inputId = "approver"
                        style = {{
                            container: base => ({
                            ...base,
                            flex: 1
                            })
                        }}
                        value = {curApprover}
                        onChange = {e => {setApprover(e)}}
                        options = {
                            usersList.filter(u => u.purchases === "approver")
                        }
                    />
                    <input
                        className = {"nodisplay"} readOnly
                        name = {"approver"} value = {curApprover?.label || ""}
                    />
                </div>
                {["Project Expense", "Vehicle Maintenance", "Outside Service Expense", "Accommodation"].includes(curCategory)?
                <div className = {"my-4"}>
                    {["Project Expense", "Outside Service Expense", "Accommodation"].includes(curCategory)?<>
                    <label htmlFor = {"billable"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Billable to Clients:
                    </label>
                    <select
                        required = {true}
                        className = {"form-control mr-3"}
                        id = {"billable"}
                        name = {"billable"}
                        value = {curBillable}
                        onChange = {e => setBillable(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        <option>Yes</option>
                        <option>No</option>
                    </select>
                    </>:<></>}
                    {curBillable === "No"?<>
                    <label htmlFor = {"includedInProposal"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Included in Proposal:
                    </label>
                    <select
                        required = {true}
                        className = {"form-control mr-3"}
                        id = {"includedInProposal"}
                        name = {"includedInProposal"}
                        value = {curIncludedInProposal}
                        onChange = {e => setIncludedInProposal(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        <option>Yes</option>
                        <option>No</option>
                    </select>
                    </>:<></>}
                    {curCategory === "Vehicle Maintenance" || (curCategory === "Project Expense" && (curIncludedInProposal === "Yes" || curBillable === "Yes"))?<>
                    <label htmlFor = {"clientInvoiceNumber"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Client Invoice Number:
                    </label>
                    <input
                        required = {true}
                        className = {"form-control"}
                        id = {"clientInvoiceNumber"}
                        name = {"clientInvoiceNumber"}
                        defaultValue = {clientInvoiceNumber}
                    />
                    </>:null}
                </div>
                :
                <input
                    className = "nodisplay" readOnly
                    name = "billable" value = "No"
                />
                }
                {user.projects !== "no" || user.outsideStatus === "yes"?<>
                <div className = {"my-4"}>
                    <label htmlFor = {"requestor"} className = {"font-weight-bold mr-3 required-field inline"}>
                        Requestor:
                    </label>
                    <div style = {{minWidth: 300, display: "inline-block"}}>
                        <Select
                            required
                            name = {"requestorEmail"}

                            inputId = "requestor"
                            style = {{
                                container: base => ({
                                ...base,
                                flex: 1
                                })
                            }}
                            value = {curRequestorEmail}
                            onChange = {e => {setRequestorEmail(e)}}
                            options = {
                                usersList.filter(u => 
                                    curCategory === "Outside Service Expense"?
                                    u.outsideStatus !== "no" || u.outside !== "no":
                                    true
                                )
                            }
                        />
                    </div>
                    {usersListMap[curRequestorEmail?.value]?.outside !== "no"?
                    <span className = {"mx-3"}>
                        {usersListMap[curRequestorEmail?.value]?.outside}&nbsp;&nbsp;
                        {usersListMap[curRequestorEmail?.value]?.btlNumber}
                        <input
                            className = {"nodisplay"} readOnly 
                            name = {"btlNumber"} value = {usersListMap[curRequestorEmail?.value]?.btlNumber ?? ""}
                        />
                    </span>:null
                    }
                </div>
                </>:null}
                <div className = "my-4">
                    <label htmlFor = {"department"} className = "font-weight-bold mr-3 required-field inline">
                        Department:
                    </label>
                    <select
                        required = {true}
                        className = {"form-control mr-3"}
                        id = "department"
                        name = "department"
                        defaultValue = {department || ""}
                    >
                        <option value = "">Select</option>
                        {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                    </select>
                </div>
                <div className = {"my-4"}>
                    <label htmlFor = {"paymentMethod"} className = "font-weight-bold mr-3 required-field inline">
                        Payment Method:
                    </label>
                    <select
                        required = {true}
                        className = "form-control mr-3"
                        id = {"paymentMethod"}
                        name = {"paymentMethod"}
                        value = {pM}
                        onChange = {e => setPM(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        {paymentMethodsData?.types?.map((p, pi) => <option key = {pi}>{p}</option>)}
                    </select>
                    {pM && availableLast4Options.length > 0?<>
                        <label htmlFor = "last4" className = "font-weight-bold mr-3 required-field inline">
                            Last 4 Digit:
                        </label>
                        <select
                            id = "last4" 
                            name = "last4" 
                            className = "form-control"
                            required = {true}
                            defaultValue = {last4 ?? ""}
                        >
                            <option value = {""}>Select</option>
                            {availableLast4Options.map((value, idx) => <option key={idx}>{value}</option>)}
                            {last4 && !availableLast4Options.includes(last4)?<option>{last4}</option>:null}
                        </select>
                        <span className = "ml-2 text-info">contact admin if not listed.</span>
                    </>:null}
                </div>
                {curCategory === "Vehicle Maintenance"?
                <div className = "my-4">
                <div style = {{display: "flex", alignItems: "center"}}>
                    <label htmlFor = "truckNumber" className = "font-weight-bold mr-3 inline">
                        Truck Number:
                    </label>
                    <div style = {{flexGrow: 1}}>
                        <Select
                            required
                            name = "truckNumberSelect"
                            inputId = "truckNumber"
                            isMulti
                            style = {{
                                container: base => ({
                                ...base,
                                flex: 1
                                })
                            }}
                            value = {curTruckNumber}
                            onChange = {e => {
                                setTruckNumber(e);
                                const selectedTruckNumbers = e?.map(c => c.truckNumber);
                                const added = selectedTruckNumbers.filter(selectedTruckNumber => !curData.map(c => c.vehicle).includes(selectedTruckNumber))
                                .map(c => ({
                                    vehicle: c,
                                    vendor: curData.length?
                                    curData[curData.length - 1].vendor:"", 
                                    description: "", 
                                    unitPrice: "", 
                                    quantity: "1", 
                                    lineTotal: ""
                                }));
                                setData([...curData, ...added].filter(c => !c.vehicle || selectedTruckNumbers.includes(c.vehicle)));
                            }}
                            options = {fleetList.map(f => ({...f, value: f.truckNumber, label: f.truckNumber}))}
                        />
                        <input
                            readOnly className = "nodisplay"
                            name = "truckNumber"
                            value = {JSON.stringify(curTruckNumber)}
                        />
                    </div>
                </div>
                {curTruckNumber?.map((truck, truckIndex) => 
                <div key = {truckIndex} className = "border rounded p-2 my-2">
                    <div className = "font-weight-bold h4">
                        Truck {truck.value}
                    </div>
                    <div className = "mt-2">
                        <label htmlFor = {`${truck.value} Category`} className = "d-inline mr-2">
                            Category
                        </label>
                        <select
                            required = {true}
                            className = {"form-control"}
                            id = {`${truck.value} Category`}
                            value = {curData.filter(c => c.vehicle === truck.value)[0]?.serviceCategory || ""} 
                            onChange = {e => {
                                const value = e.currentTarget.value;
                                let price;
                                const c = curData.filter(c => c.vehicle === truck.value)[0];
                                if(c){
                                    switch(value){
                                        case "Scheduled Maintenance":
                                            price = (window.parseFloat(c.scheduledMaintenanceLaborCost || "0") + window.parseFloat(c.scheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.scheduledMaintenanceMiscellaneousCost || "0")).toString();
                                            break;
                                        case "Unscheduled Maintenance":
                                            price = (window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.unscheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.unscheduledMaintenanceMiscellaneousCost || "0")).toString();
                                            break;
                                        case "Road Service":
                                            price = (window.parseFloat(c.roadServiceLaborCost || "0") + window.parseFloat(c.roadServiceMaterialCost || "0") + window.parseFloat(c.roadServiceMiscellaneousCost || "0")).toString();
                                            break;
                                        default:
                                    }
                                }
                                setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                    serviceCategory: value,
                                    unitPrice: price === "0"?"":price,
                                    lineTotal: price === "0"?"":price
                                }):c))
                            }}
                        >
                            <option value = "">Select</option>
                            {["Scheduled Maintenance","Unscheduled Maintenance","Road Service"].map((v, key) => <option key = {key}>{v}</option>)}
                        </select>
                    </div>
                    {curData.filter(c => c.vehicle === truck.value)[0]?.serviceCategory === 
                    "Scheduled Maintenance"?<>
                    <div className = "mt-2">
                        <label htmlFor = {`${truck.value} Vehicle Miles`} className = "d-inline mr-2">
                            Vehicle Miles
                        </label>
                        <input
                            type = {"number"}
                            min = {"0"}
                            step = {1}
                            id = {`${truck.value} Vehicle Miles`}
                            className = {"form-control"}
                            //required = {true}
                            value = {curData.filter(c => c.vehicle === truck.value)[0]?.vehicleMiles || ""}
                            onChange = {e => {
                                setData(curData.map(c => c.vehicle === truck.value? ({...c, vehicleMiles: e.currentTarget.value}):c))
                            }}
                        />
                    </div>
                    <div className = "mt-2">
                        <label htmlFor = {`${truck.value} Rear Motor Hours`} className = "d-inline mr-2">
                            Rear Motor Hours
                        </label>
                        <input
                            type = {"number"}
                            min = {"0"}
                            step = {1}
                            id = {`${truck.value} Rear Motor Hours`}
                            className = {"form-control"}
                            //required
                            value = {curData.filter(c => c.vehicle === truck.value)[0]?.rearMotorHours || ""}
                            onChange = {e => {
                                setData(curData.map(c => c.vehicle === truck.value? ({...c, rearMotorHours: e.currentTarget.value}):c))
                            }}
                        />
                    </div>
                    <div className = "mt-2">
                        <label htmlFor = {`${truck.value} Blower Hours`} className = "d-inline mr-2">
                            Blower Hours
                        </label>
                        <input
                            type = {"number"}
                            min = {"0"}
                            step = {1}
                            id = {`${truck.value} Blower Hours`}
                            className = {"form-control"}
                            //required = {true}
                            value = {curData.filter(c => c.vehicle === truck.value)[0]?.blowerHours || ""}
                            onChange = {e => {
                                setData(curData.map(c => c.vehicle === truck.value? ({...c, blowerHours: e.currentTarget.value}):c))
                            }}
                        />
                    </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Next Service Due`} className = "d-inline mr-2">
                                Next Service Due
                            </label>
                            <input
                                type = "date"
                                min = "1999-12-31"
                                max = "2999-12-31"
                                step = {1}
                                id = {`${truck.value} Next Service Due`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.nextServiceDue || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, nextServiceDue: e.currentTarget.value}):c))
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Labor Hours`} className = "d-inline mr-2">Labor Hours</label>
                            <input
                                type = {"number"}
                                step = {1}
                                id = {`${truck.value} Scheduled Maintenance Labor Hours`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.scheduledMaintenanceLaborHours || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, scheduledMaintenanceLaborHours: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Labor Cost`} className = "d-inline mr-2">Cost ($)</label>
                            <input
                                type = {"number"}
                                step = {"0.01"}
                                id = {`${truck.value} Scheduled Maintenance Labor Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.scheduledMaintenanceLaborCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        scheduledMaintenanceLaborCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.scheduledMaintenanceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.scheduledMaintenanceMiscellaneousCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Material`} className = "d-inline mr-2">
                                Material
                            </label>
                            <input
                                id = {`${truck.value} Scheduled Maintenance Material`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.scheduledMaintenanceMaterial || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, scheduledMaintenanceMaterial: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Material Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Scheduled Maintenance Material Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.scheduledMaintenanceMaterialCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        scheduledMaintenanceMaterialCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceLaborCost || "0") + window.parseFloat(c.scheduledMaintenanceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceLaborCost || "0") + window.parseFloat(c.scheduledMaintenanceMiscellaneousCost || "0")).toString()
                                    }):c))
                                
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Miscellaneous`} className = "d-inline mr-2">
                                Miscellaneous
                            </label>
                            <input
                                id = {`${truck.value} Scheduled Maintenance Miscellaneous`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.scheduledMaintenanceMiscellaneous || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, scheduledMaintenanceMiscellaneous: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Scheduled Maintenance Miscellaneous Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Scheduled Maintenance Miscellaneous Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.scheduledMaintenanceMiscellaneousCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        scheduledMaintenanceMiscellaneousCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceLaborCost || "0") + window.parseFloat(c.scheduledMaintenanceMaterialCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.scheduledMaintenanceLaborCost || "0") + window.parseFloat(c.scheduledMaintenanceMaterialCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        </>:null}
                        {curData.filter(c => c.vehicle === truck.value)[0]?.serviceCategory === 
                        "Unscheduled Maintenance"?
                        <>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Labor Hours`} className = "d-inline mr-2">
                                Labor Hours
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {1}
                                id = {`${truck.value} Unscheduled Maintenance Labor Hours`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.unscheduledMaintenanceLaborHours || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, unscheduledMaintenanceLaborHours: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Labor Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Unscheduled Maintenance Labor Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.unscheduledMaintenanceLaborCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        unscheduledMaintenanceLaborCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.unscheduledMaintenanceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceMaterialCost || "0") + window.parseFloat(c.unscheduledMaintenanceMiscellaneousCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Material`} className = "d-inline mr-2">
                                Material
                            </label>
                            <input
                                id = {`${truck.value} Unscheduled Maintenance Material`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.unscheduledMaintenanceMaterial || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, unscheduledMaintenanceMaterial: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Material Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Unscheduled Maintenance Material Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.unscheduledMaintenanceMaterialCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        unscheduledMaintenanceMaterialCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.unscheduledMaintenanceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.unscheduledMaintenanceMiscellaneousCost || "0")).toString()
                                    }):c))
                                
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Miscellaneous`} className = "d-inline mr-2">
                                Miscellaneous
                            </label>
                            <input
                                id = {`${truck.value} Unscheduled Maintenance Miscellaneous`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.unscheduledMaintenanceMiscellaneous || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, unscheduledMaintenanceMiscellaneous: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Unscheduled Maintenance Miscellaneous Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                step = {"0.01"}
                                min = {"0"}
                                id = {`${truck.value} Unscheduled Maintenance Miscellaneous Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.find(c => c.vehicle === truck.value)?.unscheduledMaintenanceMiscellaneousCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        unscheduledMaintenanceMiscellaneousCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.unscheduledMaintenanceMaterialCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.unscheduledMaintenanceMaterialCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        </>:null}
                        {curData.filter(c => c.vehicle === truck.value)[0]?.serviceCategory === 
                        "Road Service"?
                        <>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Road Service Labor Hours`} className = "d-inline mr-2">
                                Labor Hours
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {1}
                                id = {`${truck.value} Road Service Labor Hours`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceLaborHours || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, roadServiceLaborHours: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Road Service Labor Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Road Service Labor Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceLaborCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        roadServiceLaborCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.roadServiceMaterialCost || "0") + window.parseFloat(c.roadServiceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.roadServiceMaterialCost || "0") + window.parseFloat(c.roadServiceMiscellaneousCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Road Service Material`} className = "d-inline mr-2">
                                Material
                            </label>
                            <input
                                id = {`${truck.value} Road Service Material`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceMaterial || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, roadServiceMaterial: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Road Service Material Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Road Service Material Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceMaterialCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        roadServiceMaterialCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.roadServiceMiscellaneousCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.unscheduledMaintenanceLaborCost || "0") + window.parseFloat(c.roadServiceMiscellaneousCost || "0")).toString()
                                    }):c))
                                
                                }}
                            />
                        </div>
                        <div className = "mt-2">
                            <label htmlFor = {`${truck.value} Road Service Miscellaneous`} className = "d-inline mr-2">
                                Miscellaneous
                            </label>
                            <input
                                id = {`${truck.value} Road Service Miscellaneous`}
                                className = "form-control mr-2"
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceMiscellaneous || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, roadServiceMiscellaneous: e.currentTarget.value}):c))
                                }}
                            />
                            <label htmlFor = {`${truck.value} Road Service Miscellaneous Cost`} className = "d-inline mr-2">
                                Cost ($)
                            </label>
                            <input
                                type = {"number"}
                                min = {"0"}
                                step = {"0.01"}
                                id = {`${truck.value} Road Service Miscellaneous Cost`}
                                className = {"form-control"}
                                //required = {true}
                                value = {curData.filter(c => c.vehicle === truck.value)[0]?.roadServiceMiscellaneousCost || ""}
                                onChange = {e => {
                                    setData(curData.map(c => c.vehicle === truck.value? ({...c, 
                                        roadServiceMiscellaneousCost: e.currentTarget.value,
                                        unitPrice: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.roadServiceLaborCost || "0") + window.parseFloat(c.roadServiceMaterialCost || "0")).toString(),
                                        lineTotal: (window.parseFloat(e.currentTarget.value) + window.parseFloat(c.roadServiceLaborCost || "0") + window.parseFloat(c.roadServiceMaterialCost || "0")).toString()
                                    }):c))
                                }}
                            />
                        </div>
                        </>:null}
                    </div>
                    )}
                    </div>:null}
                    <div className = "table-responsive" style = {{width: "90%", margin: "auto"}}>
                        <table className = "table">
                            <thead>
                                <tr>
                                    <th>Vendor Name</th>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <th>Vehicle</th>
                                    <th>Part Number</th>
                                    </>:null}
                                    <th>Description</th>
                                    <th>Unit Price</th>
                                    <th>Quantity</th>
                                    <th>Line Total</th>
                                    <th style = {{border:"none"}}></th>
                                    <th style = {{border:"none"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {curData.map((d, i)=> 
                                <tr key = {i}>
                                    <td>
                                        <select
                                            required = {true}
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.vendor}
                                            onChange = {e => {
                                                setData(curData.map(
                                                    (dd, ii) => ii === i? 
                                                    ({
                                                        ...dd, 
                                                        vendor: e.currentTarget.value, 
                                                        vendorName: e.currentTarget.selectedOptions[0].innerText
                                                    }):dd))
                                            }}
                                        >
                                            <option value = "">Select</option>
                                            {vendorList.map((v, key) => 
                                            <option 
                                                key = {key}
                                                value = {v.vendorHashKey}
                                            >
                                                {v.vendorName}
                                            </option>)}
                                        </select>
                                    </td>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <td>
                                        {d.vehicle?
                                        <select
                                            disabled
                                            className = {"form-control"}
                                            value = {d.vehicle || ""} 
                                            onChange = {e => {
                                                setData(curData.map((dd, ii) => ii === i? ({...dd, vehicle: e.currentTarget.value}):dd))
                                            }}
                                        >
                                            <option value = "">Select</option>
                                            {curTruckNumber?.map((v, key) => <option key = {key} value = {v.value}>{v.label}</option>)}
                                        </select>
                                        :<select
                                            className = {"form-control"}
                                            value = {d.materialVehicle || ""} 
                                            onChange = {e => {
                                                setData(curData.map((dd, ii) => ii === i? ({...dd, materialVehicle: e.currentTarget.value}):dd))
                                            }}
                                        >
                                            <option value = "">Select</option>
                                            {curTruckNumber?.map((v, key) => <option key = {key} value = {v.value}>{v.label}</option>)}
                                        </select>}
                                    </td>
                                    <td>
                                        <input
                                            //required = {true}
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.partNumber || ""}
                                            onChange = {e => {
                                                const newData = curData.map((dd, ii) => ii === i? ({...dd, partNumber: e.currentTarget.value}):dd);
                                                setData(newData);
                                            }}
                                        />
                                    </td>
                                    </>:null}
                                    <td>
                                        <textarea
                                            required = {true}
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.description}
                                            onChange = {e => 
                                                setData(curData.map((dd, ii) => ii === i? ({...dd, description: e.currentTarget.value}):dd))
                                            }
                                        />
                                    </td>
                                    <td>
                                        {d.vehicle?null:
                                        <input
                                            required = {true}
                                            type = {"number"}
                                            step = {"0.01"}
                                            min = {"0"}
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.unitPrice}
                                            onChange = {e => {
                                                const newData = curData.map((dd, ii) => ii === i? ({
                                                    ...dd, 
                                                    unitPrice: e.currentTarget.value, 
                                                    lineTotal: dd.quantity !== "" && e.currentTarget.value !== ""?
                                                    (dd.quantity * e.currentTarget.value).toFixed(2):""
                                                }):dd);
                                                setData(newData);
                                            }}
                                        />}
                                    </td>
                                    <td>
                                        {d.vehicle?<></>:
                                        <input
                                            required = {true}
                                            type = {"number"}
                                            step = {"0.01"}
                                            min = {"0"}
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.quantity}
                                            onChange = {e => {
                                                const newData = curData.map((dd, ii) => ii === i? ({
                                                    ...dd, 
                                                    quantity: e.currentTarget.value, 
                                                    lineTotal: dd.unitPrice !== "" && e.currentTarget.value !== ""?
                                                    (dd.unitPrice * e.currentTarget.value).toFixed(2):""
                                                }):dd);
                                                setData(newData);
                                            }}
                                        />}
                                    </td>
                                    <td>
                                        <input
                                            type = {"number"}
                                            step = {"0.01"}
                                            readOnly
                                            className = {"form-control"}
                                            style = {{width: "100%"}}
                                            value = {d.lineTotal}
                                        />
                                    </td>
                                    <td style = {{borderTop: "none"}}>
                                        <button
                                            type = "button"
                                            className = "btn btn-primary"
                                            onClick = {() => {
                                                setData([...curData.slice(0, i + 1), {vendor: curData.length?curData[curData.length - 1].vendor:"", description: "", unitPrice: "", quantity: "", lineTotal: ""},...curData.slice(i + 1)]);
                                            }}
                                        >
                                            Add
                                        </button>
                                    </td>
                                    {curData.length === 1 || d.vehicle?null:
                                    <td style = {{borderTop: "none"}}>
                                        <button
                                            type = "button"
                                            className = "btn btn-danger"
                                            onClick = {() => {
                                                setData(curData.filter((_, ii) => ii !== i));
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </td>}
                                </tr>
                                )
                                }
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <td></td>
                                    <td></td>
                                    </>:null}
                                    <td><label htmlFor = {"subtotal"}>Subtotal:</label></td>
                                    <td>
                                        <input
                                            id = {"subtotal"}
                                            name = {"subtotal"}
                                            className = {"form-control"}
                                            type = {"number"}
                                            step = {"0.01"}
                                            min = {"0"}
                                            readOnly
                                            style = {{width: "100%"}}
                                            value = {
                                                (curData.map(d => d.unitPrice !== "" || d.quantity !== ""?
                                                (d.unitPrice * d.quantity):0).map(value => round(value, 2))
                                                .reduce(numberReducer, 0)).toFixed(2) || ""
                                            }
                                        />
                                    </td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                </tr>
                                <tr>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    </>:null}
                                    <td><label htmlFor = {"tax"}>Sales Tax:</label></td>  
                                    <td>
                                        <input
                                            required = {true}
                                            id = {"tax"}
                                            name = {"tax"}
                                            className = {"form-control"}
                                            type = {"number"}
                                            step = {"0.01"}
                                            min = {"0"}
                                            style = {{width: "100%"}}
                                            value = {curTax}
                                            onChange = {e => {setTax(e.currentTarget.value)}}
                                        />
                                    </td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                </tr>
                                <tr>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    </>:null}
                                    <td><label htmlFor = {"discount"}>Discount:</label></td>
                                    <td>
                                        <input
                                            required = {true}
                                            id = {"discount"}
                                            name = {"discount"}
                                            className = {"form-control"}
                                            type = {"number"}
                                            step = {"0.01"}
                                            max = {"0"}
                                            style = {{width: "100%"}}
                                            onChange = {e => setDiscount(e.currentTarget.value)}
                                            value = {curDiscount}
                                        />
                                    </td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                </tr>
                                <tr>
                                    <td style = {{borderTop: "none"}}></td> 
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    {curCategory === "Vehicle Maintenance"?<>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                    </>:null}
                                    <td><label htmlFor = {"total"}>Total:</label></td>
                                    <td>
                                        <input
                                            id = {"total"}
                                            name = {"total"}
                                            className = {"form-control"}
                                            type = {"number"} step = "any"
                                            readOnly
                                            style = {{width: "100%"}}
                                            value = {
                                                (curData.map(d => d.unitPrice !== "" && d.quantity !== ""?
                                                (d.unitPrice * d.quantity):0
                                                ).map(value => window.Number.parseFloat(value.toFixed(2))).reduce(numberReducer, 0) + 
                                                (curTax === ""?0:window.Number.parseFloat(curTax)) + 
                                                (curDiscount === ""?0:window.Number.parseFloat(curDiscount))).toFixed(2) || ""
                                            }
                                        />
                                    </td>
                                    <td style = {{borderTop: "none"}}></td>
                                    <td style = {{borderTop: "none"}}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {curData.map(d => d.unitPrice !== "" && d.quantity !== ""?
                    (d.unitPrice * d.quantity):0).map(value => round(value, 2))
                    .reduce(numberReducer, 0) + (curTax === ""?0:window.Number.parseFloat(curTax)) 
                    + (curDiscount === ""?0:window.Number.parseFloat(curDiscount)) 
                    > 1500?
                    <div className = "my-4">
                        <label htmlFor = "permit" className = "mr-4 font-weight-bold inline">
                            Is this for permit / license?
                        </label>
                        <select
                            required = {true}
                            className = {"form-control"}
                            id = "permit"
                            name = "permit"
                            defaultValue = {permit || ""}>
                            <option value = "">Select</option>
                            <option>No</option>
                            <option>Yes</option>
                        </select>
                    </div>
                    :null}
                    {keyword === "Add"?
                (pM !== "Pay by personal account"?
                <>
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "quotation" className = "font-weight-bold text-nowrap mr-2">Add quotation:</label>
                    <FileInput
                        accept = {"pdf"}
                        id = {"quotation"}
                        name = {"quotation"}
                    />
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "receipt" className = "font-weight-bold text-nowrap mb-0 mr-2">Add receipt:</label>
                    <FileInput
                        accept = {"pdf"}
                        id = {"receipt"}
                        name = {"receipt"}
                    />
                </div>
                </>
                :
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "receipt" className = "font-weight-bold text-nowrap mb-0 mr-2">Add receipt:</label>
                    <FileInput
                        accept = {"pdf"}
                        id = {"receipt"}
                        name = {"receipt"}
                    />
                </div>
                )
                :
                null}
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "notes" className = "font-weight-bold mb-0">
                        Notes:
                    </label>
                    <textarea
                        id = "notes"
                        name = "notes"
                        className = "form-control ml-2"
                        style = {{width: "100%"}}
                        defaultValue = {notes || ""}
                    />
                </div>
            </div>
        </Modal>
    )
}